import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleUserProfileInterface } from '../../interfaces/GoogleUserProfileInterface';
import { GoogleAgencyInterface } from '../../interfaces/GoogleAgencyInterface';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, Validators } from '@angular/forms';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';
import { HttpException } from '@rubii/share/src/classes';


@Component({
  selector: 'app-gads',
  templateUrl: './gads.component.html',
  styleUrls: ['./gads.component.scss']
})
export class GAdsComponent extends BaseDatasourceComponent implements OnInit {

  gadsCustomerIds: FormControl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, userProfilesOrAgencies: GoogleUserProfileInterface[] | GoogleAgencyInterface[] }, private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.gadsCustomerIds = new FormControl('', [Validators.required]);
  }

  connect() {
    this.client.account.addGadsCustomerIds({customerIds: this.gadsCustomerIds.value})
      .then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed'); 
        this.dialogRef.close({dataSourceId: this.data.dataSourceId});
      })
      .catch(e => this.openSnackBarWarning(this.snackBar, (e as HttpException).message, 'closed'));
  }
}
